import { useEffect, useState } from "react";
import { api } from "../lib/api";
import Hero from "../components/home/Hero";
import Marquee from "../components/Marquee";
import Legacy from "../components/home/Legacy";
import Categories from "../components/home/Categories";
import Gallery from "../components/home/Gallery";
import Testimonials from "../components/home/Testimonials";
import EditPreview from "../components/home/EditPreview";
import TrendingStrip from "../components/home/TrendingStrip";
import GetFeaturedSection from "../components/home/GetFeaturedSection";
import NewsletterBlock from "../components/NewsletterBlock";
import IGFeed from "../components/home/IGFeed";

export default function Home() {
  const [home, setHome] = useState(null);
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    Promise.all([api("/content/home"), api("/settings")])
      .then(([h, s]) => {
        setHome(h);
        setSettings(s);
      })
      .catch(() => setHome({}));
  }, []);

  if (!home) {
    return (
      <div className="min-h-screen bg-cream flex items-center justify-center" data-testid="home-loading">
        <p className="font-elegant italic text-3xl text-gold animate-pulse">The Brides of India</p>
      </div>
    );
  }

  return (
    <main data-testid="home-page">
      <Hero home={home} />
      <Marquee text={home.marquee_text} />
      <Legacy stats={home.stats} />
      <Categories />
      <Gallery items={home.gallery || []} />
      <Testimonials items={home.testimonials || []} />
      <EditPreview />
      <TrendingStrip />
      <GetFeaturedSection />
      <IGFeed home={home} settings={settings} />
      <NewsletterBlock />
    </main>
  );
}
